export default "__VITE_ASSET__D7u$MJEv__"